<template>
  <path d="M21.125 12l-8.831-8.831v5.299H2.875v7.064h9.419v5.299z"></path>
</template>
